/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { InputCorn } from "./modelInputCorn";

class ControllerInputCorn extends ControllerModel {
  constructor() {
    super("ControllerInputCorn");
    
    this.setNewNode = (callback) => {
      let inputCorn = new InputCorn();
      inputCorn.decorate(callback);

      this.addNode(inputCorn);
      SingletonFlowchart.SaveStatus()
    }

    this.loadNode = (node, callback) => {
      let inputCorn = new InputCorn();
      inputCorn.copyFrom(node);
      inputCorn.decorate(callback);
      this.addNode(inputCorn)
    }

    this.getProperties = async (node) => {
      let n = new InputCorn();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new InputCorn();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerInputCorn };
